const registerImg = name =>
  require(`../../homepage/商标注册页/images/${name}`)

export const REGISTER_BANNER = {
  src: registerImg('sbzc_06.jpg'),
  alt: '专业商标注册',
  fillLeft: 'var(--color-register-banner-fill-left)',
  fillRight: 'var(--color-register-banner-fill-right)'
}

/** 商标注册页中间内容区（1280px），不含顶部 banner 与页脚切片 */
export const REGISTER_PAGE_SECTIONS = [
  {
    type: 'columns',
    items: [
      { src: registerImg('sbzc_13.jpg'), alt: '01 安全保障' },
      { src: registerImg('sbzc_10.jpg'), alt: '02 极速申报' },
      { src: registerImg('sbzc_14.jpg'), alt: '03 专业团队' }
    ]
  },
  {
    type: 'full',
    src: registerImg('sbzc_16.jpg'),
    alt: '商标注册流程'
  },
  {
    type: 'columns',
    items: [
      { src: registerImg('sbzc_20.jpg'), alt: '为什么需要商标注册' },
      { src: registerImg('sbzc_18.jpg'), alt: '注册时长与费用' },
      { src: registerImg('sbzc_21.jpg'), alt: '选择懂标帝商标注册的优势' }
    ]
  },
  {
    type: 'full',
    src: registerImg('sbzc_22.jpg'),
    alt: '为什么选择懂标帝'
  }
]
